import React, { useState } from 'react';

import { createRoot } from 'react-dom/client';

import Toast from './Toast';

interface ToastMessage {
  id: number;
  message: string;
  variant?: 'success' | 'error' | 'warning' | 'info';
}

const ToastManager: React.FC = () => {
  const [toasts, setToasts] = useState<ToastMessage[]>([]);

  const addToast = (
    message: string,
    variant: 'success' | 'error' | 'warning' | 'info' = 'success',
  ): void => {
    const id = Date.now();
    setToasts((prev) => [...prev, { id, message, variant }]);

    // Auto-remove toast after 3 seconds
    setTimeout(() => removeToast(id), 3000);
  };

  const removeToast = (id: number): void => {
    setToasts((prev) => prev.filter((toast) => toast.id !== id));
  };

  // Attach function globally
  window.showToast = addToast;

  return (
    <div className="fixed top-3 right-3 flex flex-col gap-2">
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          message={toast.message}
          variant={toast.variant}
          onClose={() => removeToast(toast.id)}
        />
      ))}
    </div>
  );
};

// Create a container for the toast manager
const toastContainer = document.createElement('div');
document.body.appendChild(toastContainer);
const root = createRoot(toastContainer);
root.render(<ToastManager />);

export {};
